import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios, { AxiosError } from "axios";
import styled from "styled-components";
import { notification, Spin } from "antd";
import { getUrlParams } from "./shared/utils/login";
import { getBaseEndpoint } from "@bjsdistribution/tms-component-library";

const TMSClients = [
  {
    id: 1,
    name: "BJS Haulage",
    client_id: 2,
  },
  {
    id: 2,
    name: "Construct IT",
    client_id: 3,
  },
];
const Login = ({ setIsLogin }: { setIsLogin: any }) => {
  const hideLoader = () => {
    const loader = document.getElementById("global-loader");
    if (loader) {
      loader.style.display = "none";
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const errorApi = queryParams.get("error");
  const [errorMess, setErrorMess] = useState<any>(errorApi);
  const ID_TOKEN = "id_token";
  const hash = window.location.hash.substring(1);
  const params = getUrlParams(hash);
  const idToken = params.get(ID_TOKEN);
  const hashParams = new URLSearchParams(location.hash.substring(1));

  // ==============================================   Begin Login

  const BeginLogin = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get("v1/begin_login/", {
        withCredentials: true,
        baseURL,
      });
      if (response.data?.status === "success") {
        window.location.href = response.data.data;
      } else {
        navigate("/login");
      }
    } catch (error) {
      const errorMessage = error instanceof AxiosError ? error.response?.status : "Login initiation error.";
      setErrorMess(errorMessage);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  // ==============================================   sso login and set cookies and set user details allowto login

  const baseURL = getBaseEndpoint();
  const SsoLogin = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get("v1/begin_login/sso_authorization", {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        withCredentials: true,
        baseURL,
      });
      if (response?.data) {
        const userInfo = {
          first_name: response?.data?.first_names || "",
          last_name: response?.data?.last_name || "",
          username: response?.data?.username || "",
        };
        localStorage.setItem("user_details", JSON.stringify(userInfo));
        setIsLogin(true);
        navigate("/onboarding/overview");
      }
    } catch (error: any) {
      const errorMessage = error instanceof AxiosError ? error.response?.status : "Login initiation error.";

      setErrorMess(errorMessage);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  // ==============================================   switch org

  const switchOrg = async () => {
    try {
      setIsLoading(true);

      const response = await axios.put(
        "/v1/begin_login/sso/switch_organisation/",
        { organisation_id: 2 },
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          baseURL,
        }
      );

      const { code, error } = response.data;

      if (code === 200) {
        localStorage.setItem("switchAccount", JSON.stringify(true));
        notification.success({
          message: "Success",
          description: "Your account has been switched, Please relogin again",
        });
        setIsLoading(false);
        // alert("account switch please relogin again");
        console.log("account switch please relogin again");
        // window.location.reload();
      } else if (error) {
        setIsLoading(false);
        notification.error({
          message: "Error",
          description: error,
        });
      } else {
        notification.error({
          message: "Unable to switch account",
          description: "something went wrong please try again",
        });
      }
    } catch (err: any) {
      console.error(err);
      notification.error({
        message: "Error",
        description: err?.response?.data?.error || "Something went wrong",
      });
    } finally {
      setIsLoading(false);
      hideLoader();
      // window.location.reload();
    }
  };

  // ==============================================   user Profile
  const CheckUserProfile = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get("/v1/begin_login/user_profile/", {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        withCredentials: true,
        baseURL,
      });
      //@ts-ignore
      if (response?.status === 200 && response?.data?.data) {
        setIsLoading(false);
        const data = response.data.data;
        const userInfo = {
          is_supplier: data.client_identifier ?? null,
          user_id: data.user_id,
          client_id: data.client_id,
          image_url: data.image_url || null,
          username: data?.username,
        };
        localStorage.setItem("user_type", JSON.stringify(userInfo));
      } else if (response?.status === 401) {
        localStorage.removeItem("user_details");
        localStorage.removeItem("user_type");
        window.location.href = "/login?error=unauthorized access";
      } else {
        notification.error({
          message: "Error",
          description: 'something went wrong with "user_type"',
        });
      }
    } catch (error: any) {
      const status = error?.response?.status;

      if (status === 401) {
        localStorage.clear();
      } else {
        console.log("Unable to detect user type.");
      }

      setErrorMess(status || "unknown error");
    } finally {
      setIsLoading(false);
    }
  };

  // handle logic for client portal , switch org conditional and login with sso

  useEffect(() => {
    const init = async () => {
      hideLoader();

      // 1. Get User Profile
      await CheckUserProfile();

      const userProfile = JSON.parse(localStorage.getItem("user_type") || "{}");
      const isSupplierPortal = userProfile?.is_supplier;

      // 2. If idToken exists
      if (idToken) {
        if (isSupplierPortal) {
          // a. supplier portal -> directly login
          SsoLogin();
        } else {
          // b. Not customer portal -> maybe switch org
          const origin = window.location.origin;
          const shouldSkip =
            (origin.includes("tms.bjshomedelivery.com") && userProfile?.client_id === 2) ||
            (origin.includes("development.tms.bjshomedelivery.com") && userProfile?.client_id === 2) ||
            (origin.includes("staging.tms.bjshomedelivery.com") && userProfile?.client_id === 2);
          const isTMSClient = TMSClients.some((client: any) => client.client_id === userProfile?.client_id);

          if (!shouldSkip && !isTMSClient) {
            const hasSwitched = localStorage.getItem("switchAccount") === "true";
            if (hasSwitched) {
              SsoLogin();
            } else {
              await switchOrg();
            }
          } else {
            SsoLogin();
          }
        }
      }
    };

    init();
  }, [TMSClients]);

  // Begin Login for geeting token
  const loginWithSso = () => {
    BeginLogin();
  };

  const getErrorMessage = (error: any) => {
    switch (error) {
      case 401:
        return "Session expired, please log in again.";
      case 403:
        return "Access denied unable the login.";
      case 422:
        return "Unprocessable content Authentication failed .";
      default:
        return "An unknown error occurred. Please try again later.";
    }
  };

  return (
    <LoginContainer>
      <LoginBox>
        <h2>Welcome to TMS</h2>
        <button disabled={isLoading} onClick={() => loginWithSso()}>
          {" "}
          {isLoading ? <Spin /> : "Login with SSO"}
        </button>
        {queryParams.size === 0 && hashParams.size === 0 ? null : <ErrorMessage>{getErrorMessage(errorMess)}</ErrorMessage>}
      </LoginBox>
    </LoginContainer>
  );
};

export default Login;
// Styled components
const LoginContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(235 235 235);
  background-size: cover;
  /* filter: blur(5px); */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginBox = styled.div`
  width: 500px;
  height: 393px;
  background-color: white;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1;
  position: relative;

  h2 {
    margin-bottom: 30px;
  }

  p {
    position: absolute;
    bottom: 25px;
    right: 0;
    text-transform: uppercase;
    left: 0;
  }
  button {
    border: none;
    background: rgb(254, 186, 48);
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  button:disabled {
    cursor: default;
    opacity: 0.8;
  }
`;

const ErrorMessage = styled.p`
  color: #df3838;
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
`;
